import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "right-bracket",
  "use": "right-bracket-usage",
  "viewBox": "0 0 19 30",
  "content": "<symbol viewBox=\"0 0 19 30\" xmlns=\"http://www.w3.org/2000/svg\" id=\"right-bracket\"><path d=\"M0 30h9.006C14.526 30 19 25.525 19 20V10c0-5.523-4.477-10-9.994-10H0c5.354 2.863 8.996 8.506 8.996 15 0 6.495-3.642 12.137-8.996 15z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/right-bracket.svg
// module id = 594
// module chunks = 0